import { useEffect, useRef } from "react"
import {
  asyncLoadFabricImg,
  asyncSetOverlayImage,
} from "../../../../helpers/fabric"
import { fabric } from "fabric"
import shadowOverlayLayer from "./../../assets/shadow-highlight-overlay"
import * as constants from "./constants"

const extensionMap = {
  "12-display": require("./../../assets/extensions/12-display.png"),
  "6-display": require("./../../assets/extensions/6-display.png"),
  "left-table": require("./../../assets/extensions/left-table.png"),
  "right-table": require("./../../assets/extensions/right-table.png"),
}

const controls = {
  hasControls: true,
  selectable: true,
  moveCursor: true,
}

const extensionOptions = {
  "6-display": {
    scaleY: 0.47666666666666657,
    scaleX: 0.436,
    left: -6,
    top: -43.99999999999977,
  },
  "12-display": {
    scaleY: 0.47666666666666657,
    scaleX: 0.436,
    left: -6,
    top: -43.99999999999977,
  },
  "left-table": {
    scaleY: 0.45937532961626115,
    scaleX: 0.45937532961626115,
    left: -13.12410180687175,
    top: -17.875898193128194,
  },

  "right-table": {
    scaleY: 0.45937532961626115,
    scaleX: 0.45937532961626115,
    left: -66.12410180687175,
    top: -15.875898193128194,
  },
}

const loadImgWithOpts = async (imgPath, opts) => {
  const img = await asyncLoadFabricImg(imgPath)
  img.set({ ...opts, ...controls })
  return img
}

const useExtensions = (ctx, extensions) => {
  const group = useRef()

  const addExtension = async () => {
    const overlay = await loadImgWithOpts(
      shadowOverlayLayer,
      constants.SHADOW_OVERLAY
    )
    const images = await Promise.all(
      extensions
        .filter((ex) => ex !== "none")
        .map((ext) => loadImgWithOpts(extensionMap[ext], extensionOptions[ext]))
    )

    if (group.current) {
      ctx.remove(group.current)
    }
    group.current = new fabric.Group([overlay, ...images])
    await asyncSetOverlayImage(ctx, group.current)
    ctx.renderAll()
  }

  useEffect(() => {
    if (ctx) {
      addExtension()
    }
  }, [extensions, ctx])
}

export default useExtensions
